import React, { useState, useCallback, useEffect } from 'react';
import { PRODUCTS_SUBMENU } from 'constants/menu/submenus';
import { requestManufacturers } from 'requests/manufacturers';
import {
  requestPricesSearch,
  requestPricesCalculation,
  requestPricesUpdate,
} from 'requests/prices';
import { ApiErrors } from 'ui-components/ApiErrors'
import { RequestButton } from 'components/RequestButton';
import { ListPage } from 'templates/ListPage';
import { SideMenu } from 'components/SideMenu';
import { SearchForm } from './components/SearchForm';
import { Price } from './components/Price';
import { AdjustmentForm } from './components/AdjustmentForm';
import { ButtonContainer } from './styles'

export default function Prices() {
  const [manufacturers, setManufacturers] = useState([])
  const [responseError, setResponseError] = useState({})
  const [prices, setPrices] = useState([])
  const [ids, setIds] = useState([])
  const [manufacturerId, setManufacturerId] = useState()
  const [loading, setLoading] = useState(false)
  const [updating, setUpdating] = useState(false)
  const [hasChanged, setHasChanged] = useState(false)

  const getManufacturers = useCallback(async () => {
    const response = await requestManufacturers()
    if (response.error) return setManufacturers(response)

    const responseOptions = response.data.map((item) => ({
      value: item.id.toString(), label: item.attributes.name,
    }))

    return setManufacturers(responseOptions)
  }, [])

  useEffect(() => {
    getManufacturers()
  }, [getManufacturers])

  const onChange = ({ value, id }) => {
    setHasChanged(true)
    const index = prices.findIndex((price) => price.id === id)

    const updatedPrices = [...prices]
    updatedPrices[index] = { ...prices[index], selling_price: value }

    setPrices(updatedPrices)
  }

  const onSearch = async (id) => {
    setManufacturerId(id)
    setLoading(true)
    const response = await requestPricesSearch(id)

    setLoading(false)
    if (response.error) return setResponseError(response)

    const { products } = response.data.attributes
    setIds(products.map((product) => product.id))
    return setPrices(products)
  }

  const onAdjustmentApplication = async (percentage) => {
    if (!percentage) return null

    setLoading(true)
    setHasChanged(true)

    const response = await requestPricesCalculation({
      ids,
      percentage,
      manufacturer_id: manufacturerId,
    })

    setLoading(false)
    if (response.error) return setResponseError(response)

    return setPrices(response.data.attributes.products)
  }

  const onPricesUpdate = async () => {
    setUpdating(true)

    const selectedPrices = prices.filter((item) => ids.includes(item.id))
    const updatedPrices = selectedPrices.map((item) => ({
      id: item.id,
      price: item.selling_price,
    }))

    const response = await requestPricesUpdate({
      manufacturer_id: manufacturerId,
      prices: updatedPrices,
    })

    setUpdating(false)
    if (response.error) return setResponseError(response)
    return onSearch(manufacturerId)
  }

  const addPrice = (id) => {
    const selectedIds = new Set([...ids])
    selectedIds.add(id)

    setIds([...selectedIds])
  }

  const removePrice = (id) => {
    const selectedIds = ids.filter((item) => item !== id)
    setIds(selectedIds)
  }

  const onToggleSelection = (id, checked) => (
    checked ? addPrice(id) : removePrice(id)
  )

  const renderPrice = (price) => (
    <Price
      key={price.id}
      price={price}
      onChange={onChange}
      selected={ids.includes(price.id)}
      onToggleSelection={onToggleSelection}
    />
  )

  const renderSearchForm = () => (
    <SearchForm
      manufacturers={manufacturers}
      onSearch={onSearch}
    />
  )

  return (
    <ListPage
      onClickPagination={() => {}}
      onToggleForm={() => {}}
      renderMenu={() => <SideMenu submenu={PRODUCTS_SUBMENU} />}
      listTitle="Preço de produtos"
      renderSearchForm={renderSearchForm}
      openSearchForm
    >
      <ApiErrors responseError={responseError} />
      { prices.length ? (
        <AdjustmentForm
          onSubmit={onAdjustmentApplication}
          loading={loading}
          reset={updating}
        />
      ) : null }

      { prices.map(renderPrice) }

      { prices.length ? (
        <ButtonContainer>
          <RequestButton
            color="primary"
            onClick={onPricesUpdate}
            disabled={loading || !hasChanged}
            loading={updating}
            text="Atualizar preços"
          />
        </ButtonContainer>
      ) : null }
    </ListPage>
  )
}
